var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/Artboard.a0147a41.png","uri@2x": __webpack_public_path__ + "static/media/Artboard.383ce236.png","uri@3x": __webpack_public_path__ + "static/media/Artboard.7f8fe061.png",
    width: 24,
    height: 24
});